import { jsxs as l, jsx as i } from "react/jsx-runtime";
import { twMerge as a } from "tailwind-merge";
function o(s) {
  const e = s.split(/[\\/]/).pop() ?? s, t = e.lastIndexOf(".");
  return t > 0 && t < e.length - 1 ? {
    baseName: e.slice(0, t),
    extensionWithDot: e.slice(t)
  } : { baseName: e };
}
function m({ name: s, className: e }) {
  const { baseName: t, extensionWithDot: n } = o(s);
  return /* @__PURE__ */ l("div", { className: a("flex w-full", e), title: s, children: [
    /* @__PURE__ */ i("span", { className: "truncate", children: t }),
    n ? /* @__PURE__ */ i("span", { className: "shrink-0", children: n }) : null
  ] });
}
export {
  m as FileItemName
};
